// extracted by mini-css-extract-plugin
export default {"milestoneLink":"DemilestonedEvent-module__milestoneLink--JUC3Q"};